import PageLayout from './PageLayout';

export * from './PageLayout';

export default PageLayout;
